import Titles from '@ulta/core/components/Titles/Titles';

export default Titles;